import { gql } from '@apollo/client';

export default class AIQuery {
    static PULL_ACTIVE_COMPANIES = gql`
        {
            pullActiveCompanies {
                companyCode
                companyName
            }
        }
    `;

    static PULL_COMPANIES_AI_KEY_ADDED = gql`
        {
            pullCompaniesAIKeyAdded {
                companyCode
                companyName
                platform
                apiVersion
            }
        }
    `;

    static PULL_ASSISTANTS = gql`
        {
            pullAsistants {
                aiAssistantId
                name
            }
        }
    `;

    static GET_FILE_ON_BUCKET_CONTENT = gql`
        query getFileOnBucketContent($path: String!, $toString: Boolean!) {
            getFileOnBucketContent(path: $path, toString: $toString)
        }
    `;

    static PREVIEW_FILE_CONTENT = gql`
        query previewFileContent($companyCode: Int, $content: String!) {
            previewFileContent(companyCode: $companyCode, content: $content)
        }
    `;

    static GET_DYNAMIC_SECTIONS_ON_FILE = gql`
        {
            getDynamicSectionsOnFile
        }
    `;

    static GET_CUSTOM_FUNCTIONS = gql`
        {
            getCustomFunctions {
                role
                name
                description
            }
        }
    `;

    static GET_MODELS = gql`
        query getModels($companyCode: Int!) {
            getModels(companyCode: $companyCode)
        }
    `;

    static LIST_MESSAGES_IN_THREAD = gql`
        query listMessagesInThread($companyCode: Int, $threadId: String!, $runId: String, $limit: Int, $order: String!, $after: String) {
            listMessagesInThread(companyCode: $companyCode, threadId: $threadId, runId: $runId, limit: $limit, order: $order, after: $after) {
                messages {
                    id
                    role
                    createdOn
                    content {
                        type
                        value
                    }
                }
                hasMore
            }
        }
    `;

    static LIST_GLOBAL_FILES = gql`
        {
            listGlobalFiles {
                aiGlobalFileId
                name
                size
                url
            }
        }
    `;

    static PULL_ACTIVE_ASSISTANTS = gql`
        {
            pullActiveAssistants {
                aiAssistantId
                companyCode
                companyName
                assistantExternalId
                name
                instructions
                isLive
                notifyAIWhilePaused
                model
                temperature
                maxResponseTokens
                analysisEmployeeTypes
                isVoice
                voiceInitialMessage
                voiceInputNoiseReduction
                voiceOutputSpeed
                voiceCreateResponse
                voiceIdleTimeout
                voiceFinishTimeout
                voiceSilenceDuration
                voiceThreshold
                voice
                transcriptionModel
                files {
                    aiAssistantFileId
                    aiAssistantExternalFileId
                    name
                    size
                    url
                }
                functions {
                    aiAssistantFunctionId
                    description
                    function
                }
            }
        }
    `;

    static PULL_VOICE_ASSISTANTS = gql`
        query getVoiceAssistants($companyCode: Int!) {
            getVoiceAssistants(companyCode: $companyCode) {
                id
                createdAt
                name
                firstMessage
                transcriber {
                    provider
                    model
                    language
                    endpointing
                }
                model {
                    emotionRecognitionEnabled
                    maxTokens
                    temperature
                    name
                    provider
                    toolIds
                    knowledgeBase {
                        provider
                        fileIds
                    }
                    tools {
                        async
                        type
                        server {
                            url
                            timeoutSeconds
                        }
                        function {
                            name
                            description
                            parameters {
                                type
                                properties
                                required
                            }
                        }
                    }
                }
                voice {
                    provider
                    voiceId
                    model
                }
            }
        }
    `;

    static GET_CALL_DETAILS = gql`
        query getCallDetails($callId: String!) {
            getCallDetails(callId: $callId) {
                id
                type
                recordingAvailable
                messages {
                    role
                    message
                }
                status
                endedAt
                assistantId
            }
        }
    `;

    static GET_EMPLOYEE_REPORTS = gql`
        query getEmployeeReports($paginate: PaginationInput!) {
            getEmployeeReports(paginate: $paginate) {
                data {
                    employeeAnalysisReportId
                    report
                    comments
                    read
                    flagged
                    flaggedReason
                    employeeId
                    employeeType
                    createdOn
                    threadId
                }
                total
            }
        }
    `;

    static GET_ALL_EMPLOYEE_REPORTS = gql`
        query getAllEmployeeReports($paginate: PaginationInput!, $filters: [ColumnFilter]) {
            getAllEmployeeReports(paginate: $paginate, filters: $filters) {
                data {
                    employeeAnalysisReportId
                    report
                    comments
                    read
                    flagged
                    flaggedReason
                    employeeId
                    employeeType
                    createdOn
                    threadId
                }
                total
            }
        }
    `;

    static GET_AI_CONVERSATIONS_HISTORY = gql`
        query getAIConversationsHistory($conversationType: String!, $agentType: String!, $paginate: PaginationInput!) {
            getAIConversationsHistory(conversationType: $conversationType, agentType: $agentType, paginate: $paginate) {
                id
                ip
                from
                recordingURL
                crmId
                leadCode
                customerId
                firstName
                lastName
                email
                createdOn
            }
        }
    `;

    static GET_AI_CONVERSATION_DETAILS = gql`
        query getAIConversationDetails($type: String!, $id: String!) {
            getAIConversationDetails(type: $type, id: $id) {
                id
                messages {
                    role
                    message
                }
            }
        }
    `;
}
